export enum KnownUserRoles {
  Analyst = 'Analyst',
  Supervisor = 'Supervisor',
  Tenant = 'Tenant',
  AssignOwnership = 'Assign Ownership'
}
